import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils'

export const fillMethodEnum = new GenerateEnum({
  ON_SAlE: {
    value: 0,
    label: '有在售商品', // 通过商品链接AI分析
    fillName: '产品链接',
  },
  NOT_SALE: {
    value: 1,
    label: '暂未开售', // 通过回答问题分析
    fillName: '新手问题',
  },
})

export const questionTypeEnum = new GenerateEnum({
  AI: {
    value: 0,
    label: 'AI分析问题',
  },
  NORMAL: {
    value: 1,
    label: '产品问题',
  },
})

/**
 * 分析状态；AI分析中、AI分析失败、AI分析超时、AI分析不完整、已生成
 */
export const analyseStatusEnum = new GenerateEnum({
  AI_ANALYSIS_ING: {
    value: 1,
    label: 'AI分析中',
    desc: 'AI分析中',
    icon: '',
  },
  AI_ANALYSIS_FAILED: {
    value: 2,
    label: 'AI分析失败',
    desc: 'AI分析失败',
    icon: 'cha',
  },
  AI_ANALYSIS_TIMEOUT: {
    value: 3,
    label: 'AI分析超时',
    desc: 'AI分析超时',
    icon: 'zhuyi',
  },
  AI_ANALYSIS_INCOMPLETE: {
    value: 4,
    label: 'AI分析不完整',
    desc: 'AI分析不完整',
    icon: 'buwanzheng',
  },
  GENERATED: {
    value: 5,
    label: '已生成',
    desc: '方案已生成',
    icon: 'youxiao1',
  },
})

// 1. 跟进状态：已跟进/待跟进
export const followUpStatusEnum = new GenerateEnum({
  WAIT_FOR_FOLLOW_UP: {
    value: 0,
    label: '待跟进',
  },
  FOLLOWED: {
    value: 1,
    label: '已跟进',
  },
})

// 待执行、失败、进行中、已完成
export const rpaStatusEnum = new GenerateEnum({
  WAIT_FOR_EXECUTION: {
    value: 0,
    label: '待执行',
  },
  IN_PROGRESS: {
    value: 1,
    label: '进行中',
  },
  FAILURE: {
    value: 2,
    label: '失败',
  },
  COMPLETED: {
    value: 3,
    label: '已完成',
  },
})

// 待执行、失败、进行中、已完成
export const aiStatusEnum = new GenerateEnum({
  WAIT_FOR_EXECUTION: {
    value: 0,
    label: getLabelText({ key: 'remote.common.pendingExecution', text: '待执行' }),
    desc: getLabelText({ key: 'remote.common.aiAnalyzing', text: 'AI分析中' }),
    icon: '',
  },
  IN_PROGRESS: {
    value: 1,
    label: getLabelText({ key: 'remote.common.aiAnalyzing', text: 'AI分析中' }),
    desc: getLabelText({ key: 'remote.common.aiAnalyzing', text: 'AI分析中' }),
    icon: '',
  },
  FAILURE: {
    value: 2,
    label: '失败',
    desc: getLabelText({ key: 'remote.common.aiAnalysisFailed', text: 'AI分析失败' }),
    icon: 'cha',
  },
  COMPLETED: {
    value: 3,
    label: getLabelText({ key: 'remote.common.aiAnalysisCompleted', text: 'AI分析完成' }),
    desc: getLabelText({ key: 'remote.common.aiAnalysisCompleted', text: 'AI分析完成' }),
    icon: 'youxiao1',
  },
  FINISH: {
    value: 4,
    label: getLabelText({ key: 'remote.common.planGenerated', text: '已完成合规报告' }),
    desc: getLabelText({ key: 'remote.common.planGenerated', text: '已完成合规报告' }),
    icon: 'youxiao1',
  },
})

/*

产品大类

TYPE_1(1, "电子产品"),
	TYPE_2(2, "家居与厨房"),
	TYPE_3(3, "时尚"),
	TYPE_4(4, "美容与个人护理"),
	TYPE_5(5, "健康与家庭"),
	TYPE_6(6, "书籍"),
	TYPE_7(7, "运动与户外"),
	TYPE_8(8, "玩具与游戏"),
	TYPE_9(9, "宠物用品"),
	TYPE_10(10, "汽车与工业"),
	TYPE_11(11, "工具与家居改善"),
	TYPE_12(12, "办公用品"),
	TYPE_13(13, "相机与摄影"),
	TYPE_14(14, "电脑与配件"),
	TYPE_15(15, "手机与配件"),
	TYPE_16(16, "母婴用品"),
	TYPE_17(17, "食品与饮料"),
	TYPE_18(18, "园艺与户外生活"),
	TYPE_19(19, "艺术与手工艺"),
	TYPE_20(20, "乐器"),
	TYPE_21(21, "软件与视频游戏"),
	TYPE_22(22, "箱包与旅行用品"),
	TYPE_23(23, "家居装饰"),
	TYPE_24(24, "床上用品与浴室"),
	TYPE_25(25, "个人护理电器"),
	TYPE_26(26, "营养与健康"),
	TYPE_27(27, "电影与电视"),
	TYPE_28(28, "音乐"),
	TYPE_29(29, "工业与科学"),
	TYPE_30(30, "办公用品与学校用品"),

	30放到value字段，名称放到label字段
 */
export const productCategoryEnum = new GenerateEnum({
  TYPE_1: {
    value: 1,
    label: '电子产品',
  },
  TYPE_2: {
    value: 2,
    label: '家居与厨房',
  },
  TYPE_3: {
    value: 3,
    label: '时尚',
  },
  TYPE_4: {
    value: 4,
    label: '美容与个人护理',
  },
  TYPE_5: {
    value: 5,
    label: '健康与家庭',
  },
  TYPE_6: {
    value: 6,
    label: '书籍',
  },
  TYPE_7: {
    value: 7,
    label: '运动与户外',
  },
  TYPE_8: {
    value: 8,
    label: '玩具与游戏',
  },
  TYPE_9: {
    value: 9,
    label: '宠物用品',
  },
  TYPE_10: {
    value: 10,
    label: '汽车与工业',
  },
  TYPE_11: {
    value: 11,
    label: '工具与家居改善',
  },
  TYPE_12: {
    value: 12,
    label: '办公用品',
  },
  TYPE_13: {
    value: 13,
    label: '相机与摄影',
  },
  TYPE_14: {
    value: 14,
    label: '电脑与配件',
  },
  TYPE_15: {
    value: 15,
    label: '手机与配件',
  },
  TYPE_16: {
    value: 16,
    label: '母婴用品',
  },
  TYPE_17: {
    value: 17,
    label: '食品与饮料',
  },
  TYPE_18: {
    value: 18,
    label: '园艺与户外生活',
  },
  TYPE_19: {
    value: 19,
    label: '艺术与手工艺',
  },
  TYPE_20: {
    value: 20,
    label: '乐器',
  },
  TYPE_21: {
    value: 21,
    label: '软件与视频游戏',
  },
  TYPE_22: {
    value: 22,
    label: '箱包与旅行用品',
  },
  TYPE_23: {
    value: 23,
    label: '家居装饰',
  },
  TYPE_24: {
    value: 24,
    label: '床上用品与浴室',
  },
  TYPE_25: {
    value: 25,
    label: '个人护理电器',
  },
  TYPE_26: {
    value: 26,
    label: '营养与健康',
  },
  TYPE_27: {
    value: 27,
    label: '电影与电视',
  },
  TYPE_28: {
    value: 28,
    label: '音乐',
  },
  TYPE_29: {
    value: 29,
    label: '工业与科学',
  },
  TYPE_30: {
    value: 30,
    label: '办公用品与学校用品',
  },
})

// readStatus 1 已读；0 未读
export const readStatusEnum = new GenerateEnum({
  UN_READ: {
    value: 0,
    label: '未读',
  },
  READ: {
    value: 1,
    label: '已读',
  },
})

export const complianceTypeEnum = new GenerateEnum({
  VAT: {
    value: 1,
    label: 'VAT',
  },
  EPR: {
    value: 2,
    label: 'EPR',
  },
  SQDB: {
    value: 3,
    label: getLabelText({ key: 'remote.common.responsiblePerson', text: '授权代表' }),
  },
  JCRZ: {
    value: 4,
    label: getLabelText({ key: 'remote.common.testCertification', text: '检测认证' }),
  },
  IPP: {
    value: 5,
    label: getLabelText({ key: 'remote.common.trademarkService', text: '商标服务' }),
  },
  PATENT: {
    value: 6,
    label: getLabelText({ key: 'remote.common.industrialDesigns', text: '外观专利' }),
  },
  COPYRIGHT_APPLICATION: {
    value: 7,
    label: getLabelText({ key: 'remote.common.copyrightRegistration', text: '版权登记' }),
  },
  CUSTOMS_FILING: {
    value: 8,
    label: getLabelText({ key: 'remote.common.customsRecordation', text: '海关备案' }),
  },
  CPF: {
    value: 9,
    label: getLabelText({ key: 'remote.common.climatePledgeFriendlyBadge', text: 'CPF绿标' }),
  },
  CARBON_COMPLIANCE: {
    value: 10,
    label: getLabelText({ key: 'remote.common.carbonCompliance', text: '碳合规' }),
  },
  SUSTAINABLE_SUPPLY_CHAIN: {
    value: 11,
    label: getLabelText({ key: 'remote.common.sustainableSupplyChain', text: '可持续供应链' }),
  },
})



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/buyGuide.js